import { InvoiceDetails } from './InvoiceDetails';
import { EnhancementDto } from './enhancementDto';
import { ClaimsQueryDto } from './ClaimsQueryDto';
import { AccidentAndMaternity } from './AccidentAndMaternity';
import { DocumentDetails } from './DocumentDetails';
import { ClaimDocument } from './ClaimDocument';
// import { RejectReasonsDto } from './RejectReasonsDto';

export class EmailDto {
    private claimId: String;
    private emailId: String;
    private claimStatus: String;
    private oldClaimStatus: String;
    private body: String;
    private date: Date;
    private dischargeDate: Date;
    private time: String;
    private dischargeTime: String;
    private accidentAndMaternity: AccidentAndMaternity;
    
    private hospitalEmails: ClaimDocument;
    private claimDocuments!: ClaimDocument[];
    private claimAdministratorId: String;
    private providerBranchId: String;
    private admissionDate: Date;
    private invoiceDetails: InvoiceDetails;
    private enhancementEntries: EnhancementDto;
    private claimsQueryDto: ClaimsQueryDto;
    private isSubstanceAbuse: boolean;
    private isDeathCase: boolean;
    private claimRejectedBy: String;
    // private rejectReasonsDto!: RejectReasonsDto[];
    private isDataEntry: boolean;


    constructor(emailDto: any) {
        this.isDeathCase = emailDto.isDeathCase;
        this.isDataEntry = emailDto.isDataEntry;

        this.isSubstanceAbuse = emailDto.isSubstanceAbuse;
        this.claimRejectedBy = emailDto.claimRejectedBy;
        this.claimId = emailDto.claimId;
        this.emailId = emailDto.emailId;
        this.claimStatus = emailDto.claimStatus;
        this.oldClaimStatus = emailDto.oldClaimStatus;
        this.body = emailDto.body;

        if (emailDto.accidentAndMaternity) {
            this.accidentAndMaternity = new AccidentAndMaternity(emailDto.accidentAndMaternity);
        } else {
            this.accidentAndMaternity = new AccidentAndMaternity({});
        }

        if (emailDto.date) {
            this.date = new Date(emailDto.date);
        } else {
            this.date = new Date();
        }
        if (emailDto.admissionDate) {
            this.admissionDate = new Date(emailDto.admissionDate);
        } else {
            this.admissionDate = new Date();
        }
        if (emailDto.dischargeDate) {
            this.dischargeDate = new Date(emailDto.dischargeDate);
        } else {
            this.dischargeDate = new Date();
        }
        if (emailDto.hospitalEmails) {
            this.hospitalEmails = new ClaimDocument(emailDto.hospitalEmails);
        } else {
            this.hospitalEmails = new ClaimDocument({});
        }
        if (emailDto.invoiceDetails) {
            this.invoiceDetails = new InvoiceDetails(emailDto.invoiceDetails);
        } else {
            this.invoiceDetails = new InvoiceDetails({});
        }
        if (emailDto.enhancementEntries) {
            this.enhancementEntries = new EnhancementDto(emailDto.enhancementEntries);
        } else {
            this.enhancementEntries = new EnhancementDto({});
        }
        if (emailDto.claimsQueryDto) {
            this.claimsQueryDto = new ClaimsQueryDto(emailDto.claimsQueryDto);
        } else {
            this.claimsQueryDto = new ClaimsQueryDto({});
        }
        if (emailDto.time) {
            this.time = emailDto.time;
        } else {
            this.time = new Date().toLocaleTimeString().toString();
        }
        if (emailDto.dischargeTime) {
            this.dischargeTime = emailDto.dischargeTime;
        } else {
            this.dischargeTime = new Date().toLocaleTimeString().toString();
        }
        // if (emailDto.rejectReasonsDto) {
        //     this.rejectReasonsDto = [];
        //     for (const document of emailDto.rejectReasonsDto) {
        //         this.rejectReasonsDto.push(new RejectReasonsDto(document));
        //     }
        // } 
        this.claimAdministratorId = emailDto.claimAdministratorId;
        this.providerBranchId = emailDto.providerBranchId;

        if (emailDto.claimDocuments) {
            this.claimDocuments = [];
            for (const document of emailDto.claimDocuments) {
                this.claimDocuments.push(new ClaimDocument(document));
            }
        }

    }

    /**
     * Getter $isSubstanceAbuse
     * @return {boolean}
     */
	public get $isSubstanceAbuse(): boolean {
		return this.isSubstanceAbuse;
	}

    /**
     * Setter $isSubstanceAbuse
     * @param {boolean} value
     */
	public set $isSubstanceAbuse(value: boolean) {
		this.isSubstanceAbuse = value;
	}

    

    /**
     * Getter $isDataEntry
     * @return {boolean}
     */
	public get $isDataEntry(): boolean {
		return this.isDataEntry;
	}

    /**
     * Setter $isDataEntry
     * @param {boolean} value
     */
	public set $isDataEntry(value: boolean) {
		this.isDataEntry = value;
	}


    /**
     * Getter $isDeathCase
     * @return {boolean}
     */
	public get $isDeathCase(): boolean {
		return this.isDeathCase;
	}

    /**
     * Setter $isDeathCase
     * @param {boolean} value
     */
	public set $isDeathCase(value: boolean) {
		this.isDeathCase = value;
	}

      /**
     * Getter $claimRejectedBy
     * @return {String}
     */
	public get $claimRejectedBy(): String {
		return this.claimRejectedBy;
	}

    /**
     * Setter $claimRejectedBy
     * @param {String} value
     */
	public set $claimRejectedBy(value: String) {
		this.claimRejectedBy = value;
	}

    /**
     * Getter $dischargeTime
     * @return {String}
     */
	public get $dischargeTime(): String {
		return this.dischargeTime;
	}

    /**
     * Setter $dischargeTime
     * @param {String} value
     */
	public set $dischargeTime(value: String) {
		this.dischargeTime = value;
	}


    /**
     * Getter $dischargeDate
     * @return {Date}
     */
    public get $dischargeDate(): Date {
        return this.dischargeDate;
    }

    /**
     * Setter $dischargeDate
     * @param {Date} value
     */
    public set $dischargeDate(value: Date) {
        this.dischargeDate = value;
    }

    /**
     * Getter $claimsQueryDto
     * @return {ClaimsQueryDto}
     */
    public get $claimsQueryDto(): ClaimsQueryDto {
        return this.claimsQueryDto;
    }

    /**
     * Setter $claimsQueryDto
     * @param {ClaimsQueryDto} value
     */
    public set $claimsQueryDto(value: ClaimsQueryDto) {
        this.claimsQueryDto = value;
    }

    //   /**
    //  * Setter $rejectReasonsDto
    //  * @param {rejectReasonsDto} value
    //  */
    //    public set $rejectReasonsDto(value: RejectReasonsDto[]) {
    //     this.rejectReasonsDto = value;
    // }

    //  /**
    //  * Getter $rejectReasonsDto
    //  * @return {rejectReasonsDto}
    //  */
    //   public get $rejectReasonsDto(): RejectReasonsDto[] {
    //     return this.rejectReasonsDto;
    // }
    

    /**
     * Getter $claimId
     * @return {String}
     */
    public get $claimId(): String {
        return this.claimId;
    }

    /**
     * Getter $emailId
     * @return {String}
     */
    public get $emailId(): String {
        return this.emailId;
    }

    /**
     * Getter $claimStatus
     * @return {String}
     */
    public get $claimStatus(): String {
        return this.claimStatus;
    }

    /**
     * Getter $oldClaimStatus
     * @return {String}
     */
    public get $oldClaimStatus(): String {
        return this.oldClaimStatus;
    }

    /**
     * Getter $body
     * @return {String}
     */
    public get $body(): String {
        return this.body;
    }

    /**
     * Getter $date
     * @return {Date}
     */
    public get $date(): Date {
        return this.date;
    }

    /**
     * Getter $time
     * @return {String}
     */
    public get $time(): String {
        return this.time;
    }

    /**
     * Getter $hospitalEmails
     * @return {ClaimDocument}
     */
    public get $hospitalEmails(): ClaimDocument {
        return this.hospitalEmails;
    }

    /**
     * Getter $claimDocuments
     * @return {ClaimDocument[]}
     */
    public get $claimDocuments(): ClaimDocument[] {
        return this.claimDocuments;
    }

    /**
     * Getter $claimAdministratorId
     * @return {String}
     */
    public get $claimAdministratorId(): String {
        return this.claimAdministratorId;
    }

    /**
     * Getter $providerBranchId
     * @return {String}
     */
    public get $providerBranchId(): String {
        return this.providerBranchId;
    }

    /**
     * Getter $admissionDate
     * @return {Date}
     */
    public get $admissionDate(): Date {
        return this.admissionDate;
    }

    /**
     * Getter $invoiceDetails
     * @return {InvoiceDetails}
     */
    public get $invoiceDetails(): InvoiceDetails {
        return this.invoiceDetails;
    }

    /**
     * Getter $enhancementEntries
     * @return {EnhancementDto}
     */
    public get $enhancementEntries(): EnhancementDto {
        return this.enhancementEntries;
    }

    /**
     * Setter $claimId
     * @param {String} value
     */
    public set $claimId(value: String) {
        this.claimId = value;
    }

    /**
     * Setter $emailId
     * @param {String} value
     */
    public set $emailId(value: String) {
        this.emailId = value;
    }

    /**
     * Setter $claimStatus
     * @param {String} value
     */
    public set $claimStatus(value: String) {
        this.claimStatus = value;
    }

    /**
     * Setter $oldClaimStatus
     * @param {String} value
     */
    public set $oldClaimStatus(value: String) {
        this.oldClaimStatus = value;
    }

    /**
     * Setter $body
     * @param {String} value
     */
    public set $body(value: String) {
        this.body = value;
    }

    /**
     * Setter $date
     * @param {Date} value
     */
    public set $date(value: Date) {
        this.date = value;
    }

    /**
     * Setter $time
     * @param {String} value
     */
    public set $time(value: String) {
        this.time = value;
    }

    /**
     * Setter $hospitalEmails
     * @param {ClaimDocument} value
     */
    public set $hospitalEmails(value: ClaimDocument) {
        this.hospitalEmails = value;
    }

    /**
     * Setter $claimDocuments
     * @param {ClaimDocument[]} value
     */
    public set $claimDocuments(value: ClaimDocument[]) {
        this.claimDocuments = value;
    }

    /**
     * Setter $claimAdministratorId
     * @param {String} value
     */
    public set $claimAdministratorId(value: String) {
        this.claimAdministratorId = value;
    }

    /**
     * Setter $providerBranchId
     * @param {String} value
     */
    public set $providerBranchId(value: String) {
        this.providerBranchId = value;
    }

    /**
     * Setter $admissionDate
     * @param {Date} value
     */
    public set $admissionDate(value: Date) {
        this.admissionDate = value;
    }

    /**
     * Setter $invoiceDetails
     * @param {InvoiceDetails} value
     */
    public set $invoiceDetails(value: InvoiceDetails) {
        this.invoiceDetails = value;
    }

    /**
     * Setter $enhancementEntries
     * @param {EnhancementDto} value
     */
    public set $enhancementEntries(value: EnhancementDto) {
        this.enhancementEntries = value;
    }

    /**
     * Getter $accidentAndMaternity
     * @return {AccidentAndMaternity}
     */
     public get $accidentAndMaternity(): AccidentAndMaternity {
        return this.accidentAndMaternity;
    }

    /**
     * Setter $accidentAndMaternity
     * @param {AccidentAndMaternity} value
     */
     public set $accidentAndMaternity(value: AccidentAndMaternity) {
        this.accidentAndMaternity = value;
    }
}
